import { Autocomplete, Divider, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { ReactNode, useContext } from 'react'
import { createZohoIntegrationOrganizationChatbotAssignmentInterface, zohoContact, zohoDepartment, ZohoIntegrationOrganization, ZohoOrganizationAllowedField, zohoTicketFields } from '../../../../../models/axiosModel';
import integrationStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import Required from '../../../../utility/required';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';


interface ZohoConfigurationProps {
    zoho: ZohoIntegrationOrganization,
}  

interface ZohoConfigurationFormProps {
    zohoTicketFields: zohoTicketFields[],  
    handleDescriptionChangeValue: (value: string, ind: number) => void,  
    handleStaticValueChangeValue: (value: string, ind: number) => void,
    createZohoIntegrationPayload: createZohoIntegrationOrganizationChatbotAssignmentInterface, 
}

const ZohoConfiguration: React.FC<ZohoConfigurationProps | ZohoConfigurationFormProps> = (props) => {

    const flagZohoIntegrated = (props: any): props is ZohoConfigurationProps =>
        'zoho' in props;

    const { zohoContact, zohoDepartment} = useContext(IntegrationContext) as IntegrationContextPayload; 

    const breakPoints = {
        tabletScreeen: useMediaQuery<boolean>('(max-width : 1400px) and (min-width : 0px)'), 
        mobileScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
    }

    const renderDescription = (ticket: zohoTicketFields, ind: number): ReactNode => { 
        switch(ticket.zoho_ticket_field_name.toLowerCase()){
            case "department id": 
            return <>
                {!flagZohoIntegrated(props) ? 
                    <TextField 
                        className={integrationStyles.zohoTextField} 
                        value={(props.createZohoIntegrationPayload.zoho_integration_organization_field && props.createZohoIntegrationPayload.zoho_integration_organization_field.length > 0  && props.createZohoIntegrationPayload.zoho_integration_organization_field[ind]) ? props.createZohoIntegrationPayload.zoho_integration_organization_field[ind].zoho_ticket_field_description : ""}  
                        placeholder='Enter Description' 
                        onChange={(e) => props.handleDescriptionChangeValue(e.target.value, ind)} 
                        type={ticket.field_type_name.toLowerCase() === "number" ? "number" : "text"}
                    /> 
                    : <></>
                }
            </>;
            case "contact id": 
            return <> 
                {!flagZohoIntegrated(props) ? 
                    <TextField 
                        className={integrationStyles.zohoTextField} 
                        value={(props.createZohoIntegrationPayload.zoho_integration_organization_field && props.createZohoIntegrationPayload.zoho_integration_organization_field.length > 0  && props.createZohoIntegrationPayload.zoho_integration_organization_field[ind]) ? props.createZohoIntegrationPayload.zoho_integration_organization_field[ind].zoho_ticket_field_description : ""}  
                        placeholder='Enter Description' 
                        onChange={(e) => props.handleDescriptionChangeValue(e.target.value, ind)} 
                        type={ticket.field_type_name.toLowerCase() === "number" ? "number" : "text"}
                    /> 
                    :
                    <></>
                }
            </>; 
            default: 
            return <> 
                {!flagZohoIntegrated(props) ? 
                <TextField 
                    className={integrationStyles.zohoTextField} 
                    value={(props.createZohoIntegrationPayload.zoho_integration_organization_field && props.createZohoIntegrationPayload.zoho_integration_organization_field.length > 0  && props.createZohoIntegrationPayload.zoho_integration_organization_field[ind]) ? props.createZohoIntegrationPayload.zoho_integration_organization_field[ind].zoho_ticket_field_description : ""}  
                    placeholder='Enter Description' 
                    onChange={(e) => props.handleDescriptionChangeValue(e.target.value, ind)} 
                    type={ticket.field_type_name.toLowerCase() === "number" ? "number" : "text"}
                /> 
                : 
                <></>
                }
            </>
        }
    } 
    
    const renderStaticValue = (ticket: zohoTicketFields, ind: number): ReactNode => {
    switch(ticket.zoho_ticket_field_name.toLowerCase()){
        case "department id": 
        return <>
            {!flagZohoIntegrated(props) ? 
                <Autocomplete
                className={integrationStyles.zohoFieldsDropdown} 
                sx={{ backgroundColor: "white", width: "100%", minWidth: breakPoints.tabletScreeen ? "250px" : "300px" }}
                options={zohoDepartment ? zohoDepartment : []} 
                value={zohoDepartment ? zohoDepartment.find(department => department.id === props.createZohoIntegrationPayload?.zoho_integration_organization_field?.[ind]?.zoho_ticket_field_static_value) : null} 
                getOptionLabel={(option) => option.name} 
                renderInput={(params) => <TextField {...params} placeholder="Select" />} 
                onChange={(e, value) => props.handleStaticValueChangeValue(value ? value.id : "", ind)}
                /> 
                : <></>
            }
        </>; 
        case "contact id": 
        return <>
            {!flagZohoIntegrated(props) ? 
            <Autocomplete
                className={integrationStyles.zohoFieldsDropdown} 
                sx={{ backgroundColor: "white", width: "100%", minWidth: breakPoints.tabletScreeen ? "250px" : "300px" }} 
                options={zohoContact ? zohoContact : []}  
                value={zohoContact ? zohoContact.find((contact) => contact.id === props.createZohoIntegrationPayload?.zoho_integration_organization_field?.[ind]?.zoho_ticket_field_static_value) : null}
                getOptionLabel={(option) => ( option.firstName ? option.firstName : "") + " " + option.lastName} 
                renderInput={(params) => <TextField {...params} placeholder="Select" />} 
                onChange={(e, value) => props.handleStaticValueChangeValue(value ? value.id : "", ind)}
            />
            : <></>
            }
        </>; 
        default: 
        return <>
            {!flagZohoIntegrated(props)? 
            <TextField 
                className={integrationStyles.zohoTextField} 
                value={(props.createZohoIntegrationPayload.zoho_integration_organization_field && props.createZohoIntegrationPayload.zoho_integration_organization_field.length > 0  && props.createZohoIntegrationPayload.zoho_integration_organization_field[ind]) ? props.createZohoIntegrationPayload.zoho_integration_organization_field[ind].zoho_ticket_field_static_value : ""}  
                placeholder='Enter Static Value' 
                onChange={(e) => props.handleStaticValueChangeValue(e.target.value, ind)}  
                type={ticket.field_type_name.toLowerCase() === "number" ? "number" : "text"}
            />
            : <></>
            }
        </>;
    }
    }  


    const findSpecificDepartment = (id: string | null) => {
        if(zohoDepartment && id){
            const res = zohoDepartment.find((department: zohoDepartment) => {
            return department.id == id;
            }); 
            if(res) return res.name;
            return "-";
        }
        return "-";
    } 

    const findSpecificContact = (id: string | null) => {
        if(zohoContact && id){
            const res = zohoContact.find((contact: zohoContact) => {
            return contact.id == id;
            });
            if(res) return (res.firstName ? res.firstName : "") + " " + res.lastName; 
            return "-";
        }
        return "-"; 
    }

    const renderStaticValueInfo = (field: ZohoOrganizationAllowedField): ReactNode | string => {
        switch(field.zoho_ticket_field_name.toLowerCase()){
            case "department id":
            return findSpecificDepartment(field.zoho_ticket_field_static_value); 
            case "contact id": 
            return findSpecificContact(field.zoho_ticket_field_static_value);
            default: 
            return field.zoho_ticket_field_static_value ? field.zoho_ticket_field_static_value : "-";
        }
    }

  return (
    <>
      <Grid container display={"flex"} direction={"column"} gap={breakPoints.mobileScreen ? "15px" : "20px"}>
            <>
                {!flagZohoIntegrated(props) ? 
                    <>
                        {props.zohoTicketFields && 
                            props.zohoTicketFields.sort((a, b) => a.zoho_ticket_field_seq - b.zoho_ticket_field_seq).map((ticket: zohoTicketFields, ind: number) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <Grid item>
                                            <Typography className={integrationStyles.ticketFieldTitle}>{ticket.zoho_ticket_field_name} <Required /></Typography>
                                            <Divider sx={{ margin: breakPoints.mobileScreen ? "4px 0 8px 0" : "8px 0 12px 0", opacity: "1 !important"}} />
                                            <Grid item>
                                                <Grid container justifyContent={"start"} gap={"15px"}>
                                                    {ticket.flag_required && 
                                                        <Grid item>
                                                            <Grid container direction={"column"} gap={"7px"}>
                                                                <Grid item>
                                                                    <Typography className={integrationStyles.ticketSubjectStaticValueTitle}>Description Text</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    {renderDescription(ticket, ind)}
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    } 
                                                    <Grid item>
                                                        <Grid container direction={"column"} gap={"7px"}>
                                                            <Grid item>
                                                                <Typography className={integrationStyles.ticketSubjectStaticValueTitle}>Static Value</Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                {renderStaticValue(ticket, ind)}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                );
                            })
                        }
                    </>
                    : 
                    <>
                        {props.zoho && 
                            props.zoho.zoho_organization_allowed_field_data.map((field: ZohoOrganizationAllowedField, ind: number) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <Grid item sx={{width: "100%"}}>
                                            <Typography className={integrationStyles.ticketFieldTitle}>{field.zoho_ticket_field_name}</Typography>
                                            <Divider sx={{ margin: breakPoints.mobileScreen ? "4px 0 8px 0" : "8px 0 12px 0", opacity: "1 !important"}} />
                                            <Grid item>
                                                <Grid container justifyContent={"start"} gap={"15px"}>
                                                    <Grid item xs={4}>
                                                        <Grid container direction={"column"} gap={"7px"}>
                                                            <Grid item>
                                                                <Typography className={integrationStyles.ticketSubjectStaticValueTitle}>Description</Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography className={integrationStyles.ticketFieldValues}>{field.zoho_ticket_field_description ? field.zoho_ticket_field_description : "-"}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Grid container direction={"column"} gap={"7px"}>
                                                            <Grid item>
                                                                <Typography className={integrationStyles.ticketSubjectStaticValueTitle}>Static Value</Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography className={integrationStyles.ticketFieldValues}>{renderStaticValueInfo(field)}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                )
                            })
                        }
                    </>
                }
            </>
      </Grid>
    </>
  )
}

export default ZohoConfiguration
